import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const triggerCopScan = api(async function triggerCopScan({ codeOfPracticeId, authorityFilter, resume }) {
    return mutate(
        gql`
            mutation TriggerCopScan($codeOfPracticeId: ID!, $authorityFilter: [String], $resume: Boolean) {
                triggerCopScan(codeOfPracticeId: $codeOfPracticeId, authorityFilter: $authorityFilter, resume: $resume)
            }
        `,
        { codeOfPracticeId, authorityFilter, resume },
        { returns: "triggerCopScan" }
    )
})
